import { IssueFragment } from '@spotify/plugin-confidence-issues-react';

type ObservationTheme = Extract<
  IssueFragment['theme'],
  { __typename: 'ObservationsV1Theme' }
>;

export const getIssueTheme = (issue: IssueFragment): ObservationTheme | null =>
  issue.theme?.__typename === 'ObservationsV1Theme' ? issue.theme : null;
